export const addressErrorMixin = {
    methods: {
        setAddressError(errorMessage) {
            const errors = this.$store.state.order.errors;
            errors.addressOk = [errorMessage];
            this.$store.commit('order/setErrors', errors);
        }
    }
}